const MarketingConsent = () => (
    <div style={{ fontSize: 13, lineHeight: 1.9 }}>
        <p style={{ marginBottom: 16 }}>
            (주)에이아이에스(이하 "회사")는 이용자에게 유익한 서비스 정보를
            제공하기 위해 아래와 같이 마케팅 정보 수신에 대한 동의를 받고
            있습니다. 본 동의는 선택사항이며, 동의하지 않으셔도 생육관리시스템
            서비스 이용에는 제한이 없습니다.
        </p>

        {/* ── 1. 수집 목적 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            1. 마케팅 정보 수신 동의 목적
        </h4>
        <p style={{ marginBottom: 8 }}>
            회사는 다음과 같은 목적으로 마케팅 정보를 발송합니다.
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>
                생육관리시스템 서비스의 신규 기능 및 업데이트 안내
            </li>
            <li style={{ marginBottom: 4 }}>
                농작업 관련 유용한 정보 및 콘텐츠 제공
            </li>
            <li style={{ marginBottom: 4 }}>
                이벤트, 프로모션 및 할인 혜택 안내
            </li>
            <li style={{ marginBottom: 4 }}>
                서비스 관련 설문조사 및 이용후기 요청
            </li>
            <li style={{ marginBottom: 4 }}>
                제휴사 및 파트너사의 상품·서비스 정보 제공
            </li>
        </ul>

        {/* ── 2. 수집 항목 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            2. 수집하는 개인정보 항목
        </h4>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>이름</li>
            <li style={{ marginBottom: 4 }}>휴대전화번호</li>
            <li style={{ marginBottom: 4 }}>이메일주소</li>
        </ul>

        {/* ── 3. 발송 채널 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            3. 마케팅 정보 발송 채널
        </h4>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>
                문자메시지(SMS/MMS/카카오 알림톡)
            </li>
            <li style={{ marginBottom: 4 }}>이메일(E-mail)</li>
            <li style={{ marginBottom: 4 }}>앱 푸시 알림(App Push)</li>
        </ul>

        {/* ── 4. 보유 및 이용기간 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>4. 보유 및 이용기간</h4>
        <p style={{ marginBottom: 12 }}>
            마케팅 수신 동의 시점부터 회원 탈퇴 또는 수신 동의 철회 시까지
            이용됩니다. 단, 관련 법령에 따라 보존이 필요한 경우에는 해당
            법령에서 정한 기간 동안 보유합니다.
        </p>

        {/* ── 5. 동의 철회 방법 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>5. 동의 철회 방법</h4>
        <p style={{ marginBottom: 8 }}>
            이용자는 언제든지 마케팅 정보 수신 동의를 철회할 수 있으며, 수신
            동의 철회 이후에는 마케팅 목적의 개인정보 이용을 즉시 중단합니다.
            철회 방법은 다음과 같습니다.
        </p>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>
                서비스 앱 내 설정 → 알림 설정에서 수신 동의 철회
            </li>
            <li style={{ marginBottom: 4 }}>이메일 내 수신거부 링크 클릭</li>
            <li style={{ marginBottom: 4 }}>
                고객센터 연락 (070-5158-5952 / cs@aiskorea.co.kr)
            </li>
        </ul>

        {/* ── 6. 미동의 시 불이익 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>
            6. 동의 거부 권리 및 불이익 안내
        </h4>
        <p style={{ marginBottom: 12 }}>
            이용자는 마케팅 정보 수신 동의를 거부할 권리가 있으며, 거부 시에도
            생육관리시스템의 기본 서비스 이용에는 제한이 없습니다. 다만,
            동의하지 않으실 경우 이벤트 참여 및 각종 혜택 안내를 받으실 수
            없습니다.
        </p>

        {/* ── 7. 문의처 ── */}
        <h4 style={{ marginTop: 20, marginBottom: 8 }}>7. 문의처</h4>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
            <li style={{ marginBottom: 4 }}>
                담당부서: (주)에이아이에스 개인정보보호팀
            </li>
            <li style={{ marginBottom: 4 }}>전화번호: 070-5158-5952</li>
            <li style={{ marginBottom: 4 }}>전자우편: cs@aiskorea.co.kr</li>
        </ul>

        <p style={{ marginTop: 24, color: '#888', fontSize: 12 }}>
            공고일자: 2026년 3월 19일 &nbsp;|&nbsp; 시행일자: 2026년 3월 19일
        </p>
    </div>
);

export default MarketingConsent;
